import { FetchClient } from "../../lib/tools";

class AbstractCalls {
  static buildCallUri(backend, useCase) {
    const backendUriKey = `VITE_${backend.toUpperCase()}_SERVICE_URI`;
    const backendUri = import.meta.env[backendUriKey];
    if (!backendUri) {
      throw new Error(`Backend '${backend}' is not configured, expected key: ${backendUriKey}`);
    }

    return new URL(useCase, backendUri).toString();
  }

  static get(cmdUri, body, options) {
    return FetchClient.get(cmdUri, body, options);
  }

  static post(cmdUri, body, options) {
    return FetchClient.post(cmdUri, body, options);
  }

  static patch(cmdUri, body, options) {
    return FetchClient.patch(cmdUri, body, options);
  }

  static delete(cmdUri, body, options) {
    return FetchClient.delete(cmdUri, body, options);
  }

  static put(cmdUri, body, options) {
    return FetchClient.put(cmdUri, body, options);
  }

  static sendFile(cmdUri, file, options) {
    return FetchClient.sendFile(cmdUri, file, options);
  }
}

export default AbstractCalls;
